import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateTipoExpedienteRequest } from '@models/tipoExpediente/createTipoExpedienteRequest.model';
import { UpdateTipoExpedienteRequest } from '@models/tipoExpediente/updateTipoExpedienteRequest.model';
import { CreateTipoAudienciaRequest } from '@models/tipoAudiencia/createTipoAudienciaRequest.model';
import { UpdateTipoAudienciaRequest } from '@models/tipoAudiencia/updateTipoAudienciaRequest.model';

@Injectable({
  providedIn: 'root'
})
export class TipoAudienciaService {

  constructor(private http:HttpClient) {
  }

  create(createTipoAudienciaRequest:CreateTipoAudienciaRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/TipoAudiencia/Create",createTipoAudienciaRequest);
  }

  update(updateTipoAudienciaRequest:UpdateTipoAudienciaRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TipoAudiencia/Update",updateTipoAudienciaRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/TipoAudiencia/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/TipoAudiencia/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoAudiencia/Delete?id=" + id);
    else
      return of(null)
  }

}
